module.exports = __webpack_public_path__ + "static/media/1.b4ed80d5.jpg";